import { useEffect } from 'react';
import { useNotificationsSummary } from '../../notifications/hooks/useNotificationsSummary';

/**
 * Custom event name for refreshing friend request count
 * Dispatched when friend requests are accepted/rejected/negotiated
 * Note: This is now handled by useNotificationsSummary, but kept for backward compatibility
 */
export const FRIEND_REQUEST_COUNT_REFRESH_EVENT = 'friendRequestCountRefresh';

/**
 * Hook to get the count of incoming friend requests
 * Used for showing notification badges in navigation
 * 
 * Now uses useNotificationsSummary for combined polling (friend requests + unread chats)
 * Listens to custom events to trigger refresh when requests are handled
 */
export function useFriendRequestCount(): number {
  const { summary, refresh } = useNotificationsSummary();
  
  // Listen for custom refresh events (dispatched when requests are handled)
  useEffect(() => {
    const handleRefresh = () => {
      refresh();
    };
    
    window.addEventListener(FRIEND_REQUEST_COUNT_REFRESH_EVENT, handleRefresh);
    
    return () => {
      window.removeEventListener(FRIEND_REQUEST_COUNT_REFRESH_EVENT, handleRefresh);
    };
  }, [refresh]);
  
  return summary.pendingFriendRequests;
}
